import { EAEAEA_PIXEL } from "@faire/deprecated-retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { optimizeProductImageUrl } from "@faire/web/common/transform-images";
import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import React from "react";
import styled from "styled-components";

interface IProps {
  images: (IImage | undefined)[];
  imageSize: number;
  className?: string;
  gap?: string;
}

export const ImageGrid: React.FC<IProps> = (props) => {
  const { images, imageSize, gap = "2px", className } = props;
  const fallbackImages = new Array(3).fill(undefined);
  const isSSR = useIsSSR();

  return (
    <Grid $gap={gap} className={className}>
      {images
        .concat(fallbackImages)
        .slice(0, 3)
        .map((image, index) => (
          <ImageWrapper $isFirst={index === 0} $gap={gap} key={index}>
            <img
              src={
                image
                  ? optimizeProductImageUrl(image, isSSR, imageSize)
                  : EAEAEA_PIXEL
              }
            />
            {image ? <TransparencyOverlay /> : null}
          </ImageWrapper>
        ))}
    </Grid>
  );
};

const ImageWrapper = styled.div<{ $isFirst: boolean; $gap: string }>`
  position: relative;
  width: 100%;
  padding-top: calc(100% - ${(props) => props.$gap});
  ${(props) => (props.$isFirst ? "grid-row: 1 / span 2;" : "")}

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Grid = styled.div<{ $gap: string }>`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: ${(props) => props.$gap};
  flex-shrink: 0;
`;
